<template>
    <DialogLayout>
        <form @submit.prevent="handleSubmit">
            <h3 class="Modal__title">Mot de passe oublié ?</h3>
            <p class="Modal__text">
                Afin de réinitialiser votre mot de passe, veuillez saisir ci-dessous votre adresse-mail
                et suivre le lien qui vous sera envoyé.
            </p>
            <input-material @input="handleChange" :required="true" type="email" label="Adresse e-mail" v-model="email"
                            :error="errors.email"/>
            <div class="text-center">
                <button :disabled="loading" class="Btn Btn--primary Btn--gradient Btn--shadow m-t-30">
                    <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                    <span v-else>Envoyer <i class="fas fa-caret-right m-l-5"></i></span>
                </button>
            </div>
        </form>
    </DialogLayout>
</template>
<script>
    import InputMaterial from "../../InputMaterial";
    import DialogLayout from "../Layouts/DialogLayout";
    import validate from "../../../validator/validator";
    import Rules from '../../../validator/rules';
    import {isEmpty} from "../../../utils";
    import ModalBus from "../../../eventBus";
    import Api from "../../../services/Api";

    export default {
        components: {DialogLayout, InputMaterial},
        data: function () {
            return {
                email: null,
                loading: false,
                errors: {}
            }
        },
        methods: {
            handleChange: function(){
                this.errors = {};
            },
            handleSubmit: async function () {
                let data = {email: this.email},
                    errors = validate(data, {
                        email: [Rules.required(), Rules.email()]
                    });

                if (!isEmpty(errors)) {
                    this.errors = errors;
                    return;
                }

                this.loading = true;

                try {
                    let data = {email: this.email};

                    await this.$recaptchaLoaded();
                    data['g-recaptcha-response'] = await this.$recaptcha('signup');

                    await Api.post('/auth/password/email', data);
                    ModalBus.alertSuccess(
                        'Lien de réinitialisation envoyé !',
                        'Veuillez vérifier vos emails, un lien permettant de réinitialiser votre mot de passe vous a été envoyé. Pensez à vérifier vos spams.'
                    );
                    this.loading = false;
                } catch (err) {
                    if (err.response?.data?.errors) {
                        this.errors = err.response.data.errors;
                        this.loading = false;
                    } else {
                        ModalBus.processingError();
                    }
                }
            }
        }
    }
</script>
